import { render, staticRenderFns } from "./AR.vue?vue&type=template&id=1307d27b&scoped=true&"
import script from "./AR.vue?vue&type=script&lang=ts&"
export * from "./AR.vue?vue&type=script&lang=ts&"
import style0 from "./AR.vue?vue&type=style&index=0&id=1307d27b&scoped=true&lang=css&"
import style1 from "./AR.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307d27b",
  null
  
)

export default component.exports